/**
 * Card lists must pick the same icon as FlowView: ScenarioIcon when a
 * scenario exists (ruleType/order, source on the left), FlowIcon otherwise
 * (alphabetical FlowChannelDef key).
 */
export function getFlowCardIconSource(flow) {
    return flow && flow.scenario ? 'scenario' : 'flow';
}
